import React from 'react';
import { QuillEditorInputComponent } from '../components/quill-editor-input.component';

let isOnChangeTriggered = false;
export function QuillEditorInputContainer({ value, onValueChange, label, isRequired, readOnly }: any) {
  return (
    <QuillEditorInputComponent
      value={value}
      label={label}
      isRequired={isRequired}
      onChange={(constant: any) =>
        {
          isOnChangeTriggered = true;
          onValueChange(constant)
        }
      }
      readOnly={readOnly}
      theme="snow"
    />
  );
}

